import { gql } from '@apollo/client';

export const GET_RATES = gql`
  query getRates {
    getRates {
      success
      message
      error
      data
    }
  }
`;


export const GET_HSC_RATE_HISTORIES= gql`
  query getHSCRateHistories {
    getHSCRateHistories {
      success
      message
      error
      data
    }
  }
`;
